/**
 * Shared geo utilities for map and list filtering.
 */

const CITY_COORDS = {
  beograd: { lat: 44.7866, lng: 20.4489 },
  'novi sad': { lat: 45.2671, lng: 19.8335 },
  nis: { lat: 43.3209, lng: 21.8958 },
  kragujevac: { lat: 44.0167, lng: 20.9167 },
  subotica: { lat: 46.1, lng: 19.6667 },
  belgrade: { lat: 44.7866, lng: 20.4489 },
};

const DEFAULT_COORDS = { lat: 44.7866, lng: 20.4489 };

function normalizeCityKey(value) {
  return value
    ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    : '';
}

/** Get approximate coordinates for a city name (for items without lat/lng). */
export function getCityCoordinates(city) {
  if (!city) return null;
  const key = normalizeCityKey(city);
  return key ? (CITY_COORDS[key] || DEFAULT_COORDS) : null;
}
